import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class OpenPageModel {
  public selectedPageOpen = false;
  public feedbackPageOpen = false;
  public contactPageOpen = false;
  public imprintOpen = false;
  public helpOpen = false;
  public termsOpen = false;
  public sfChatPageOpen = false;
}

@Injectable({
  providedIn: 'root',
})
export class OpenPageService {
  public readonly openPageSource = new BehaviorSubject(new OpenPageModel());
  public readonly currentOpenPage = this.openPageSource.asObservable();

  changeOpenPage(openPage: OpenPageModel): void {
    this.openPageSource.next(openPage);
  }

  closeOpenPage(): void {
    this.openPageSource.next(new OpenPageModel());
  }
}
